<template>
  <s-modal
    v-model="showModal"
    class="action-to-require-password"
    centered
    :title="$t(title)"
    :ok-title="$t(okTitle)"
    :ok-disabled="!canSave"
    @cancel="closeModal"
    @ok="submit"
  >
    <b-container fluid>
      <b-row align-h="between" align-v="center">
        <b-col cols="12">
          <b-form-group>
            <div
              class="action-to-require-password__label"
              v-html="$t(message, internalMessageParams)"
            ></div>
            <div
              class="action-to-require-password__label"
              v-html="$t(labelField)"
            ></div>
            <password-eye
              v-model="password"
              id="password"
              autocomplete="new-password"
              :maxlength="maxLength"
              :state="$bsStateValidator($v.password.$error)"
              :errorMessage="errorMessage"
              @input="onLostFocusError"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import PasswordEye from '@/components/inputs/PasswordEye';

export default {
  components: {
    PasswordEye,
  },
  props: {
    title: {
      type: String,
    },
    okTitle: {
      type: String,
      default: 'general.confirm',
    },
    labelField: {
      type: String,
      default: 'user-manager.action-to-require-password-modal.label-field',
    },
    message: {
      type: String,
    },
    messageParams: {
      type: Object,
      default: () => null,
    },
  },
  data: () => ({
    showModal: false,
    user: {
      id: null,
      name: null,
    },
    password: null,
    maxLength: 20,
    errorMessage: null,
  }),
  validations: {
    password: {
      required,
      maxLength: maxLength(20),
    },
  },
  computed: {
    canSave() {
      return this.$v.password.required;
    },
    internalMessageParams() {
      const params = {
        userName: this.user.name || this.user.username,
      };
      return this.messageParams ? this.messageParams : params;
    },
  },
  methods: {
    clear() {
      this.user = {
        id: null,
        name: null,
      };
      this.password = null;
      this.errorMessage = null;
      this.$v.$reset();
    },
    show(user) {
      this.clear();
      this.user = user;
      this.showModal = true;
      this.$emit('emit-modal-state', true);
    },
    submit() {
      this.$emit('submit', {
        ...this.user,
        password: this.password,
      });
      this.showModal = false;
      this.errorMessage = null;
      this.$emit('emit-modal-state', false);
    },
    closeModal() {
      if (this.showModal) {
        this.$emit('ok');
        this.showModal = false;
        this.errorMessage = null;
        this.$emit('emit-modal-state', false);
      }
    },
    feedbackMessage() {
      const field = this.$t('login.password');
      const message = this.$t('messages.MA001.message');
      const feedback = message.replace('{NomeDoCampo}', field);
      return feedback;
    },
    onLostFocusError() {
      this.$v.password.$touch();
      if (this.$v.password.$error) {
        this.errorMessage = this.feedbackMessage();
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.action-to-require-password
  &__label
    display: inline-block
    margin-bottom: 0.5rem
</style>
